<template>
  <div id="consulter">
    <router-link to="/heures">
      <img class="imgicon" src="img/back.png" />
    </router-link>
    <h2>Consultation des heures</h2>
    <div class="mt-3 form-inline filtre">
      <label for="begindate">Date</label>
      <date-picker
        @change="onDateChange"
        @clear="onClearDate"
        type="date"
        format="dd DD/MM/YYYY"
        v-model="filters.date"
      />
      <a href="javascript:" @click="setAjd()">&nbsp;Aujourd'hui</a>
      <span class="ml-3">ou</span>
    </div>
    <div class="mt-3 form-inline filtre">
      <label for="begindate">Date de début</label>
      <date-picker
        :disabled="filters.date !== null"
        name="begindate"
        @change="onDateChange"
        format="dd DD/MM/YYYY"
        v-model="filters.begindate"
      ></date-picker>
      <label class="ml-3" for="enddate">Date de fin</label>
      <date-picker
        :disabled="filters.date !== null"
        name="enddate"
        @change="onDateChange"
        format="dd DD/MM/YYYY"
        v-model="filters.enddate"
      ></date-picker>
      <label class="ml-3" for="enddate">Par période salariale:</label>
      <vue-monthly-picker
        name="monthpicker"
        @selected="onChange"
        :dateFormat="'MM/YYYY'"
        :monthLabels="labels"
        v-model="date"
        :clearOption="true"
      ></vue-monthly-picker>
    </div>
    <hr />
    <div class="custom-control custom-switch">
      <input
        @change="loadData"
        v-model="global"
        type="checkbox"
        class="custom-control-input"
        id="globalswitch"
      />
      <label
        class="custom-control-label"
        for="globalswitch"
      >{{ global ? `Rapport global` : `Rapport par employé` }}</label>
    </div>
    <hr />
    <div v-if="global">
      <h3>Rapport global</h3>
      <a href="javascript:" class="mr-3" @click="generatePDFSummary()">
        <img class="imgicon" src="img/pdf.png" /> Télécharger en PDF
      </a>
      <hr />
      <h5
        style="color: black"
      >Total des heures (Normal): {{toDecimalHour(totalNormal)}}</h5>
      <h5
        style="color: black"
      >Total des heures (RHT): {{toDecimalHour(totalRHT)}}</h5>
      <h4
        style="color: black"
      >Total des heures: {{toDecimalHour(total)}}</h4>
      <p v-if="filteredResumes.length <= 0">Pas d'heure à afficher pour le moment</p>
      <div v-for="resume of filteredResumes" :key="resume.id_employe">
        <hr />
        <h5
          style="color: black"
        >{{employesById[resume.id_employe].nom}} {{employesById[resume.id_employe].prenom}}
        <a href="javascript:" class="mr-3 float-right" style="font-size: 0.8em" @click="generatePDF(resume.id_employe)">
            <img class="imgicon" src="img/pdf.png" /> Résumé en PDF
          </a>
        </h5>
        <div class="table-responsive">
          <table class="mt-3 table table-hover">
            <tbody>
              <tr v-for="c of resume.cumuls" :key="c.id_fonction">
                <td style="width: 16.66%">{{fonctionsById[c.id_fonction].nom}}</td>
                <td style="width: 33.34%">{{toDecimalHour(c.cumul)}}</td>
                <th style="width: 16.66%"></th>
                <td style="width: 33.34%"></td>
              </tr>
              <tr class="table-primary">
                <th style="width: 16.66%">Total Normal</th>
                <td
                  style="width: 33.34%"
                >{{toDecimalHour(resume.totalNormal)}}</td>
                <th style="width: 16.66%">Total RHT</th>
                <td
                  style="width: 33.34%"
                >{{toDecimalHour(resume.totalRHT)}}</td>
              </tr>
              <tr class="table-primary">
                <th style="width: 16.66%">Total</th>
                <td
                  style="width: 33.34%"
                >{{toDecimalHour(resume.total)}}</td>
                <th style="width: 16.66%"></th>
                <td style="width: 33.34%"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else>
      <h3>Rapport par employé</h3>
      <div class="row">
        <div class="col-8">
          <div class="form-group">
            <select @change="loadData" v-model="employe" class="custom-select">
              <option :value="undefined">Sélectionner un employé</option>
              <option
                v-for="e of employes"
                :key="e.id"
                :value="e.id"
              >{{e.acronyme}} - {{e.nom}} {{e.prenom}}</option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <a v-if="employe" href="javascript:" class="mr-3" @click="generatePDF(employe)">
            <img class="imgicon" src="img/pdf.png" /> Télécharger en PDF
          </a>
        </div>
      </div>
      <div v-if="employe">
        <div class="table-responsive">
          <table class="mt-3 table table-hover">
            <thead>
              <tr>
                <th>Date</th>
                <th>Site</th>
                <th>Fonction</th>
                <th>A1-D1</th>
                <th>A2-D2</th>
                <th>A3-D3</th>
                <th>A4-D4</th>
                <th>A5-D5</th>
                <th>A6-D6</th>
                <th>Cumul</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="heure of heures" :key="heure.id">
                <td>{{utils.toPrettyDate(heure.date)}}</td>
                <td>{{sitesById[heure.id_site].nom}}</td>
                <td>{{fonctionsById[heure.id_fonction].nom}}</td>
                <td>
                  <plage-horaire :a="heure.a1" :d="heure.d1" />
                </td>
                <td>
                  <plage-horaire :a="heure.a2" :d="heure.d2" />
                </td>
                <td>
                  <plage-horaire :a="heure.a3" :d="heure.d3" />
                </td>
                <td>
                  <plage-horaire :a="heure.a4" :d="heure.d4" />
                </td>
                <td>
                  <plage-horaire :a="heure.a5" :d="heure.d5" />
                </td>
                <td>
                  <plage-horaire :a="heure.a6" :d="heure.d6" />
                </td>
                <td>{{toDecimalHour(heure.cumul)}}</td>
              </tr>
            </tbody>
          </table>
          <h6
            style="color: black"
          >Total des heures (Normal): {{toDecimalHour(totalNormal)}}</h6>
          <h6
            style="color: black"
          >Total des heures (RHT): {{toDecimalHour(totalRHT)}}</h6>
          <h5
            style="color: black"
          >Total des heures: {{toDecimalHour(total)}}</h5>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api";
import utils from "@/utils";
import VueMonthlyPicker from "vue-monthly-picker";
import moment from "moment";
import PlageHoraire from "../components/PlageHoraire";
import DatePicker from "vue2-datepicker";

export default {
  data() {
    return {
      utils,
      date: undefined,
      begin: moment().set("date", 21).subtract(1, "month"),
      end: moment().set("date", 20),
      labels: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ],
      global: true,
      employes: [],
      sitesById: [],
      fonctionsById: [],
      employesById: [],
      heures: [],
      resumes: [],
      filters: {
        begindate: null,
        enddate: null,
        date: null,
      },
      totalRHT: "",
      totalNormal: "",
      total: "",
      employe: undefined,
      moment,
    };
  },
  components: { VueMonthlyPicker, PlageHoraire, DatePicker },
  async created() {
    let infosById = (await api.getInfosById()).data;
    this.sitesById = infosById.sitesById;
    this.fonctionsById = infosById.fonctionsRhtById;
    this.employes = (await api.getEmployes()).data.employes;
    for (let employe of this.employes) {
      this.employesById[employe.id] = employe;
    }
    this.periodes = (await api.getPeriodes()).data.periodes;
    let today = moment();
    let ok = false;
    for (let i = 0; i < this.periodes.length; i++) {
      let diff =
        moment(this.periodes[i][1]).year() - moment(this.periodes[i][0]).year();
      let a = moment(this.periodes[i][0]).set("year", today.year() - diff);
      let b = moment(this.periodes[i][1]).set("year", today.year());
      if (today.isBetween(a, b, undefined, "[]")) {
        today.set("month", i);
        ok = true;
        break;
      }
    }
    if (!ok) {
      today.add(1, "month");
    }
    this.date = today;
    this.onChange();
  },
  methods: {
    setAjd() {
      this.filters.date = new Date();
      this.onDateChange();
    },
    toDecimalHour(hours){
      return (Math.round(moment.duration(hours).asHours()*100)/100).toFixed(2);
    },
    onDateChange() {
      if (this.filters.date) {
        this.filters.begindate = this.filters.date;
        this.filters.enddate = this.filters.date;
      }
      this.datealert =
        this.filters.begindate !== null &&
        this.filters.enddate !== null &&
        moment(this.filters.begindate).isAfter(this.filters.enddate, "day");
      this.date = undefined;
      this.loadData();
    },
    onClearDate() {
      this.filters.begindate = null;
      this.filters.enddate = null;
      this.date = undefined;
    },
    async onChange() {
      let month = moment(this.date).month();
      let year = moment(this.date).year();
      let diff =
        moment(this.periodes[month][1]).year() -
        moment(this.periodes[month][0]).year(); //On recale l'année des périodes sur l'année en cours
      this.filters.begindate = moment(this.periodes[month][0])
        .set("year", year - diff)
        .toDate();
      this.filters.enddate = moment(this.periodes[month][1])
        .set("year", year)
        .toDate();
      this.filters.date = null;
      this.loadData();
    },
    async loadData() {
      this.$store.commit("setLoading", true);
      if (this.global) {
        let response = (
          await api.getHeuresSummary(
            moment(this.filters.begindate).format("YYYY-MM-DD"),
            moment(this.filters.enddate).format("YYYY-MM-DD")
          )
        ).data;
        this.resumes = response.resumes;
        this.totalRHT = response.totalRHT;
        this.totalNormal = response.totalNormal;
        this.total = response.total;
      } else {
        if (this.employe !== undefined) {
          let response = (
            await api.getHeuresByEmploye(
              moment(this.filters.begindate).format("YYYY-MM-DD"),
              moment(this.filters.enddate).format("YYYY-MM-DD"),
              this.employe
            )
          ).data;
          this.heures = response.heures;
          this.totalRHT = response.resume.totalRHT;
          this.totalNormal = response.resume.totalNormal;
          this.total = response.total;
        }
      }
      this.$store.commit("setLoading", false);
    },
    generatePDF(employe) {
      api.pdf(
        `heures/employe/${employe}`,
        {
          filters: {
            begindate: moment(this.filters.begindate).format("YYYY-MM-DD"),
            enddate: moment(this.filters.enddate).format("YYYY-MM-DD"),
          },
        },
        `${this.employesById[employe].nom}-${this.employesById[employe].prenom}-${moment(this.filters.begindate).format(
          "YYYY-MM-DD"
        )}-${moment(this.filters.enddate).format("YYYY-MM-DD")}-heures`
      );
    },
    generatePDFSummary() {
      api.pdf(
        `heures/summary`,
        {
          filters: {
            begindate: moment(this.filters.begindate).format("YYYY-MM-DD"),
            enddate: moment(this.filters.enddate).format("YYYY-MM-DD"),
          },
        },
        `heures-global-${moment(this.filters.begindate).format(
          "YYYY-MM-DD"
        )}-${moment(this.filters.enddate).format("YYYY-MM-DD")}`
      );
    },
  },
  computed: {
    filteredResumes() {
      return this.resumes.filter((resume) => {
        return resume.total !== "00:00:00";
      });
    },
  },
};
</script>